module.exports = __webpack_public_path__ + "static/media/Eb4.58fa3d6d.mp3";